import Path from "../../../../layouts/Path";
import { Button, Group, Stack, TextInput, Title } from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../components/View/BackButton";
import { createUrlShortened } from "../../../../api/ConfigsApi";

const CreateUrlPage = () => {
  const lang = useLanguage((s) => s.language);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);
    createUrlShortened(data?.name, data?.url)
      .then((response) => {
        setTimeout(() => {
          notifications.show({
            message: lang.url_shortener.row_highlight.created,
            color: "tertiary.8",
          });
        }, 300);
        navigate(`../?highlight=${response.data.shortened_url_id}`);
      })
      .finally(() => setLoading(false));
  };
  return (
    <>
      <Group
        className="layout-block top"
        w={"100%"}
        gap={0}
        justify="space-between"
      >
        <Path />
      </Group>
      <Stack
        className="layout-block"
        w={"40%"}
        mx={"auto"}
        gap={"xs"}
        component={"form"}
        onSubmit={handleSubmit}
      >
        <Title order={5}>{lang.url_shortener.create.dialog.title}</Title>
        <TextInput
          name="name"
          label={lang.url_shortener.create.dialog.name}
          placeholder={lang.url_shortener.create.dialog.name}
          autoFocus
          required
        />

        <TextInput
          name="url"
          type="url"
          label={lang.url_shortener.create.dialog.url}
          placeholder={lang.url_shortener.create.dialog.url}
          required
        />

        <Group justify="flex-end" mt={"sm"}>
          <BackButton />
          <Button type="submit" loading={loading}>
            {lang.url_shortener.create.dialog.submit_button}
          </Button>
        </Group>
      </Stack>
    </>
  );
};

export default CreateUrlPage;
